var _defs, _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _path5, _path6, _path7, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPainPointShoulder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.113,
    height: 77.326,
    viewBox: "0 0 67.113 77.326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3701",
    "data-name": "Rectangle 3701",
    width: 27.918,
    height: 26.125,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3702",
    "data-name": "Rectangle 3702",
    width: 21.027,
    height: 21.022,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3703",
    "data-name": "Rectangle 3703",
    width: 16.783,
    height: 15.958,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3704",
    "data-name": "Rectangle 3704",
    width: 13.732,
    height: 12.104,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3712",
    "data-name": "Rectangle 3712",
    width: 40.134,
    height: 33.536,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3707",
    "data-name": "Rectangle 3707",
    width: 35.248,
    height: 29.366,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3706",
    "data-name": "Rectangle 3706",
    width: 24.227,
    height: 20.184,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3709",
    "data-name": "Rectangle 3709",
    width: 32.043,
    height: 27.086,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3710",
    "data-name": "Rectangle 3710",
    width: 17.023,
    height: 14.182,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3711",
    "data-name": "Rectangle 3711",
    width: 5.065,
    height: 4.22,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3713",
    "data-name": "Rectangle 3713",
    width: 12.632,
    height: 8.163,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3714",
    "data-name": "Rectangle 3714",
    width: 9.842,
    height: 13.913,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3715",
    "data-name": "Rectangle 3715",
    width: 5.192,
    height: 5.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3716",
    "data-name": "Rectangle 3716",
    width: 14.561,
    height: 5.117,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3717",
    "data-name": "Rectangle 3717",
    width: 10.539,
    height: 12.746,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3718",
    "data-name": "Rectangle 3718",
    width: 12.379,
    height: 9.312,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4687",
    "data-name": "Group 4687",
    transform: "translate(-1697.556 -621.642)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5510",
    "data-name": "Path 5510",
    d: "M29.644,345.345,46.768,329.2s10.068-2.41,5.482,2.38l-1.583,4.231-4.573.626L31.432,356.361l-9.2-5.128s-6.191-3.139-10.1-12.446c3-3.364,10.794-5.146,10.794-5.146,1.409,2.018,6.71,11.7,6.71,11.7",
    transform: "translate(1686.931 334.028)",
    fill: "#ffb080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5511",
    "data-name": "Path 5511",
    d: "M113.161,217.373s11.838,2.764,11.508,3.4c-.315,2.243,2.755,6.538,2.755,6.538s-9.275,1.938-13.259.244c-6.481-2.777-4.607-4.484-4.607-4.484,1.62-.442,3.6-5.7,3.6-5.7",
    transform: "translate(1601.88 431.377)",
    fill: "#f9a475"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5512",
    "data-name": "Path 5512",
    d: "M108.377,36.045s23.764-22.106,25.121-2.939c.1,1.461-.851,3.136-1.505,6.185a43.971,43.971,0,0,0-.283,6.274c-.2.533-1.019,2.263-1.157,2.794-1.075,4.132-1.759,6.321-1.759,6.321H124.43s-8.275-1.177-11.183-3.628c-5.391-4.544-4.091-7.394-4.091-7.394,1.62-.442-.779-7.613-.779-7.613",
    transform: "translate(1602.694 599.508)",
    fill: "#ffb080"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M51.553,273.761l-5.4-14.736L31.3,250.213s-8.3,1.983-13.276,0c-4.992-1.976-4.3-4.562-4.3-4.562l-8.946-1.038-3.8,4.56L0,260.049l1.764,6.1L3.05,270.03l2.668-.944,2.393,6.9,3.794,6.949.435,3.109-.31,2.552a38.752,38.752,0,0,0,30.66-.674l-1.066-2.235,3.253-1.878,8.341-3.021q.323-.307.638-.622Z",
    transform: "translate(1697.556 407.534)",
    fill: "#7cc2e0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(1720.894 654.698)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5514",
    "data-name": "Path 5514",
    d: "M196.368,284.074l-6.485-6.009s-4.359-5.6-2.093-10.327c1.28-2.67,5.52-2.67,5.52-2.67l1.792,3.049,14.85,8.812,5.1,13.923s-8.9,1.549-13.654-1.953Z",
    transform: "translate(-187.138 -265.069)",
    fill: "#ff3131"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004",
    transform: "translate(1726.514 657.747)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5515",
    "data-name": "Path 5515",
    d: "M239.1,304.089l-5.471-5.325s-3.745-8.169.923-9.245l14.85,8.812,3.833,10.459s-5.19,3.76-9.943.259Z",
    transform: "translate(-232.209 -289.519)",
    fill: "#ff3131"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007",
    transform: "translate(1728.822 659.308)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5516",
    "data-name": "Path 5516",
    d: "M258.1,313.509l-6.594-4.814s-2.7-5.544,1.875-6.663l12.22,7.252,1.9,5.176s-1.9,5.688-7.384,2.624Z",
    transform: "translate(-250.719 -302.031)",
    fill: "#ff3131"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(1730.599 660.094)",
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M270.009,316.5l-3.481-2.142s-3.927-4.9.647-6.023L278.07,314.8l.623,1.7s-.4,6.393-5.15,2.892Z",
    transform: "translate(-264.96 -308.339)",
    fill: "#ff3131"
  }))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M23.948,6.04c-.918,4.05-.813,9.079.557,15.02.875,3.793-.94,9.095-1.6,11.486-4.935,17.9-.879,20.2,5.392,24.7,12.132,8.7,15.042,1.386,14.006-9.191-.5-5.075-6.457-16.638-3.939-20.941C40.339,23.776,63.113,11.532,58.6,2.576A38.723,38.723,0,0,0,23.948,6.04",
    transform: "translate(1679.431 621.642)",
    fill: "#221e3f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M333.779,540.3q.506,1.206.966,2.282a38.72,38.72,0,0,0,10.523-7.083c-1.332.247-8.759,1.744-11.489,4.8",
    transform: "translate(1405.402 152.924)",
    fill: "#ffb080"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M272.094,290.884c.425.73.751,1.332.935,1.748.44,2.448,6.56,6.5,6.955,5.56l3.1-2.189,1.234-2.918-3.006-4.2s-3.7-.932-5.436-2.41a45.972,45.972,0,0,0-3.778,4.409",
    transform: "translate(1459.394 370.893)",
    fill: "#ffb080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034",
    transform: "translate(1718.638 650.519)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(1.868 2.295)",
    opacity: 0.51,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M185.671,261.918c4.092,7.967,14.567,15.645,23.4,17.15s12.669-3.734,8.577-11.7-14.567-15.645-23.4-17.15-12.669,3.734-8.577,11.7",
    transform: "translate(-184.033 -249.96)",
    fill: "#ff3131",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(5.099 4.741)",
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M226.049,296.2c2.813,5.476,10.012,10.753,16.081,11.788s8.708-2.566,5.895-8.042-10.012-10.753-16.081-11.788-8.708,2.566-5.895,8.042",
    transform: "translate(-224.923 -287.978)",
    fill: "#ff3131",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M252.1,318.731a17.633,17.633,0,0,0,11.3,8.283c4.264.727,6.118-1.8,4.142-5.651a17.633,17.633,0,0,0-11.3-8.283c-4.264-.727-6.119,1.8-4.142,5.651",
    transform: "translate(-242.915 -305.1)",
    fill: "#ff3131",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    opacity: 0.39,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M200.634,265.092c-.3,0-.6-.009-.909-.025l.032-.6a14.627,14.627,0,0,0,2.337-.051l.064.594a14.371,14.371,0,0,1-1.524.079m-2.517-.18c-.241-.033-.489-.071-.737-.113-.535-.091-1.086-.2-1.639-.337l.14-.581c.539.129,1.077.24,1.6.329.241.041.483.078.717.11Zm5.65-.184-.148-.579a7.834,7.834,0,0,0,2.121-.867l.309.511a8.431,8.431,0,0,1-2.282.934m-9.579-.687c-.748-.225-1.515-.488-2.281-.782l.214-.558c.752.289,1.5.547,2.238.767Zm13.166-1.276-.427-.418a5.566,5.566,0,0,0,1.215-1.894l.557.216a6.166,6.166,0,0,1-1.345,2.1m-16.933-.115c-.721-.314-1.453-.661-2.176-1.03l.272-.532c.712.363,1.433.7,2.143,1.014Zm-3.59-1.786c-.691-.387-1.387-.8-2.067-1.231l.32-.505c.671.424,1.357.833,2.039,1.214Zm22.277-1.8-.592-.082a8.007,8.007,0,0,0,.072-1.088,9.7,9.7,0,0,0-.079-1.215l.593-.075a10.309,10.309,0,0,1,.084,1.29,8.574,8.574,0,0,1-.078,1.169m-25.685-.312c-.659-.45-1.316-.923-1.951-1.406l.362-.476c.627.477,1.275.944,1.926,1.388Zm-3.209-2.4c-.622-.509-1.235-1.037-1.821-1.57l.4-.442c.578.527,1.183,1.048,1.8,1.55Zm28-1.2a16.224,16.224,0,0,0-.761-2.216l.551-.233a16.833,16.833,0,0,1,.788,2.3Zm-30.986-1.474c-.578-.567-1.14-1.15-1.669-1.734l.443-.4c.521.575,1.074,1.15,1.644,1.709Zm29.571-2.144-.012-.022c-.347-.675-.743-1.362-1.177-2.043l.5-.322c.442.693.845,1.393,1.2,2.08l.008.016-.269.134Zm-32.292-.8c-.523-.63-1.019-1.271-1.474-1.906l.486-.348c.447.624.934,1.254,1.448,1.872Zm30.218-2.567c-.448-.624-.935-1.255-1.448-1.873l.46-.382c.522.629,1.018,1.27,1.474,1.906Zm-32.6-.671c-.445-.7-.851-1.4-1.206-2.093l.264-.14.267-.134-.267.134.268-.133c.347.675.743,1.363,1.179,2.045Zm30.111-2.395c-.521-.575-1.074-1.15-1.644-1.709l.418-.427c.579.568,1.14,1.151,1.669,1.734Zm-32-1.164a16.857,16.857,0,0,1-.788-2.3l.578-.15a16.231,16.231,0,0,0,.76,2.216Zm29.21-1.63c-.578-.526-1.182-1.047-1.8-1.55l.378-.463c.623.509,1.236,1.037,1.821,1.57Zm-30.309-2.267a10.3,10.3,0,0,1-.084-1.288,8.6,8.6,0,0,1,.078-1.172l.592.082a8.007,8.007,0,0,0-.073,1.09,9.679,9.679,0,0,0,.079,1.213Zm27.27-.262c-.628-.478-1.276-.945-1.926-1.388l.337-.494c.658.449,1.314.922,1.951,1.406Zm-3.249-2.258c-.671-.425-1.357-.833-2.039-1.214l.292-.521c.691.386,1.386.8,2.067,1.23ZM170.1,236.193l-.557-.216a6.167,6.167,0,0,1,1.345-2.1l.427.418a5.57,5.57,0,0,0-1.215,1.893m19.625-.632c-.713-.364-1.434-.705-2.143-1.014l.239-.548c.72.314,1.452.66,2.176,1.03Zm-3.6-1.613c-.752-.289-1.5-.547-2.238-.767l.172-.572c.748.225,1.515.488,2.281.782Zm-13.618-.583-.309-.511a8.433,8.433,0,0,1,2.282-.934l.148.579a7.845,7.845,0,0,0-2.121.866m9.859-.6c-.54-.13-1.079-.241-1.6-.329-.241-.041-.481-.078-.715-.11l.081-.592c.24.033.487.071.735.113.535.091,1.088.2,1.641.337Zm-6.214-.539-.064-.594a15.234,15.234,0,0,1,2.433-.053l-.032.6a14.677,14.677,0,0,0-2.337.051",
    transform: "translate(-169.052 -231.556)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(3.57 3.627)",
    opacity: 0.37,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5525",
    "data-name": "Path 5525",
    d: "M220.123,287.5c-7.867-1.341-17.248-8.234-20.911-15.366-1.734-3.375-2.01-6.415-.777-8.56,1.4-2.435,4.621-3.419,8.837-2.7,7.867,1.341,17.249,8.234,20.912,15.366,1.734,3.375,2.01,6.415.777,8.56a5.492,5.492,0,0,1-2.98,2.405,11.583,11.583,0,0,1-5.858.3M200.05,264.827c-.935,1.627-.68,4.019.716,6.738,3.344,6.51,11.963,12.811,19.213,14.047,3.575.61,6.259-.144,7.367-2.068.934-1.626.68-4.019-.717-6.737-3.344-6.51-11.963-12.811-19.214-14.047a10.057,10.057,0,0,0-5.062.229,4.232,4.232,0,0,0-2.3,1.838",
    transform: "translate(-197.677 -260.643)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    transform: "translate(10.57 10.037)",
    opacity: 0.39,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5526",
    "data-name": "Path 5526",
    d: "M254.6,317.817a17.634,17.634,0,0,0,11.3,8.282c4.264.727,6.119-1.8,4.142-5.651a17.633,17.633,0,0,0-11.3-8.282c-4.264-.727-6.118,1.8-4.142,5.651m2.031.38c-1.44-2.8-.089-4.647,3.019-4.118a12.85,12.85,0,0,1,8.234,6.036c1.44,2.8.089,4.647-3.019,4.118a12.85,12.85,0,0,1-8.234-6.036",
    transform: "translate(-253.806 -312.042)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031",
    transform: "translate(16.485 15.042)",
    opacity: 0.39,
    style: {
      mixBlendMode: "color-dodge",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5527",
    "data-name": "Path 5527",
    d: "M302.71,352.208a5.247,5.247,0,0,1,3.362,2.464c.588,1.145.036,1.9-1.232,1.681a5.247,5.247,0,0,1-3.362-2.464c-.588-1.145-.036-1.9,1.232-1.681",
    transform: "translate(-301.242 -352.171)",
    fill: "#ff3131"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037",
    transform: "translate(1720.476 672.47)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5528",
    "data-name": "Path 5528",
    d: "M193.643,412.97l-1.69-1.784-4.485,4.551-3.677-3,7.382-3.88,1.583,1.462,3.667-2.747Z",
    transform: "translate(-183.791 -407.575)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(1719.557 645.973)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5529",
    "data-name": "Path 5529",
    d: "M186.266,209.016l-5.483-5.776.661-2.606-5.02-5.532,5.787,3.541-.118,4.331Z",
    transform: "translate(-176.424 -195.103)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043",
    transform: "translate(1747.807 652.929)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5530",
    "data-name": "Path 5530",
    d: "M408.143,250.885l-3.456,1.643.934,2.127-2.671,2.13,4.144-.472-1.412-3.106Z",
    transform: "translate(-402.951 -250.885)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(1710.568 661.989)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5531",
    "data-name": "Path 5531",
    d: "M118.9,325.991l-6.941,2.658-1.14-2.7-6.414.1-.066-2.524,8.913.035-.627,3.283Z",
    transform: "translate(-104.341 -323.532)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(1745.84 679.636)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5532",
    "data-name": "Path 5532",
    d: "M387.175,465.042l3.1,7.793,2.581-1.789,3.779,6.742,1.079-4.255-5.293-6.525-1.742,3.181Z",
    transform: "translate(-387.175 -465.042)",
    fill: "#ff3131"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(1752.29 670.759)",
    opacity: 0.52,
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5533",
    "data-name": "Path 5533",
    d: "M438.9,398.474l5.531.718-.049,3.974,6.9-1.377-4.794-1.313-.726-6.622Z",
    transform: "translate(-438.901 -393.853)",
    fill: "#ff3131"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3719",
    "data-name": "Rectangle 3719",
    width: 67.113,
    height: 77.326,
    transform: "translate(1697.556 621.642)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainPointShoulder);
export default __webpack_public_path__ + "static/media/painPointShoulder.fc39a08b5504f8175f799d06d2e6249a.svg";
export { ForwardRef as ReactComponent };